var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavIconRequestGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1243_410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5 4C14.1266 4 11.8066 4.70379 9.83316 6.02236C7.85977 7.34094 6.3217 9.21509 5.41345 11.4078C4.5052 13.6005 4.26756 16.0133 4.73058 18.3411C5.1936 20.6689 6.33649 22.8071 8.01472 24.4853C9.69295 26.1635 11.8312 27.3064 14.1589 27.7694C16.4867 28.2324 18.8995 27.9948 21.0922 27.0866C23.2849 26.1783 25.1591 24.6402 26.4776 22.6668C27.7962 20.6935 28.5 18.3734 28.5 16C28.5 12.8174 27.2357 9.76515 24.9853 7.51472C22.7348 5.26428 19.6826 4 16.5 4ZM18.5 18L10.5 22L14.5 14L22.5 10L18.5 18Z",
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 10L14.5 14L10.5 22L18.5 18L22.5 10Z",
    fill: "#F8F8F8",
    stroke: "#F8F8F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1243_410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconRequestGrey);
export default __webpack_public_path__ + "static/media/NavIconRequestGrey.687bdf31a2edbcda9d536d59e03b9375.svg";
export { ForwardRef as ReactComponent };